import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs = [{
  question: '¿Es complicado para mí?',
  answer: 'No. Tú me cuentas sobre tu negocio y yo traduzco todo eso a una web clara y bonita. Sin que tengas que hablar técnico.'
}, {
  question: '¿Puedo aprobar el diseño?',
  answer: 'Sí. Vamos viendo la dirección juntos para que la página se sienta como tu marca antes de publicarla.'
}, {
  question: '¿Cómo empezamos?',
  answer: 'Con un mensaje. Me cuentas qué haces, para quién y qué te gustaría lograr con tu página.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-14" data-mp="2n8bwp2p0on5g">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-15" data-mp="2n6r25d2pd47l">
        <div data-id="element-16" data-mp="2s0bqedehujtl">
          <Reveal data-id="element-17" data-mp="2s0v9hxfvre97">
            <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-coral" data-id="element-18" data-mp="14va9vs932mzq">Preguntas rápidas</p>
          </Reveal>
          <Reveal delay={0.05} data-id="element-19" data-mp="10ui08xwaug2x">
            <h2 className="mt-4 font-display text-5xl font-extrabold leading-[0.92] text-ink" data-id="element-20" data-mp="10v9x0c1mujus">Sin vueltas raras.</h2>
          </Reveal>
        </div>

        <div className="divide-y-2 divide-ink border-y-2 border-ink" data-id="element-21" data-mp="19un6v5to5ag1">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <Reveal key={faq.question} delay={index * 0.06} data-id="element-22" data-mp="1ol44sf73hi86" data-mpi={index}>
                <div data-id="element-23" data-mp="1jjolosoh9lsf">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-300" data-id="element-24" data-mp="1jmasgq3jnx9l">
                    <span className="text-base font-extrabold tracking-[-0.025em] text-ink sm:text-lg" data-id="element-25" data-mp="3udays0y8rayp">{faq.question}</span>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center bg-lime text-ink" data-id="element-26" data-mp="1yaxtz6mr3i2t">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-27" data-mp="23a0zstak1sbu" /> : <PlusIcon className="h-4 w-4" data-id="element-28" data-mp="286rdxb2sudum" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-29" data-mp="2c94i3v1we3pa">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: [0.22, 1, 0.36, 1]
                }} data-id="element-30" data-mp="2h8h4yfsrrarv">
                        <p className="max-w-2xl pb-5 text-sm leading-relaxed text-slate-600 sm:text-base" data-id="element-31" data-mp="2vvtu0ehsbyn0">{faq.answer}</p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}